import { Component, OnInit } from '@angular/core';
import { Apiservice } from '../services/ApiService';
import { AuthService } from '../services/AuthService';
import { PermissionsService } from '../services/Permissions';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'attendance-reporting-tool';
  isLoggedin;
  admin;
  ticketmaster;
  deliveryAdmin;
  venueAdmin;
  globalAdmin;
  scan;
  loading: boolean = false;


  constructor(private apiService: Apiservice, private auth: AuthService, private route: Router, private permissions: PermissionsService) {
    this.isLoggedin = this.auth.isLoggedIn;
    this.admin = this.permissions.admin;
    this.ticketmaster = this.permissions.ticketmaster;
    this.deliveryAdmin = this.permissions.deliveryAdmin;
    this.venueAdmin = this.permissions.venueAdmin;
    this.globalAdmin = this.permissions.globalAdmin;
    this.scan = this.permissions.scan;

    this.route.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.loading = true;  
      } 
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loading = false; 
      }
    });

  }



  getCurrentUser(){
    this.permissions.checkPermissions();
  }

  loadingStatus(){
    this.loading = true;
  }

  toggleModernView(): void {
    // Modern view is the default, so treat an unset flag as "modern" — this makes
    // the first click on the version label flip the user to the old (legacy) view.
    const stored = localStorage.getItem('attendanceUseModernView');
    const current = stored === null ? true : stored === 'true';
    const next = !current;
    localStorage.setItem('attendanceUseModernView', String(next));
    window.dispatchEvent(new CustomEvent('attendance-modern-view-changed', { detail: next }));
  }

  async signOut() {
    await this.auth.signOut();
    this.route.navigate(['/login']);
  }

  ngOnInit(): void {
    this.permissions.checkPermissions();
  }
}
